import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';


function ForgotPasswordReset() {

    const verifyCode = localStorage.getItem('verify_code');

    const [values, setValues] = useState({ password: '', confirm_password: '' });
    const navigate = useNavigate();
    axios.defaults.withCredentials = true;


    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
   
    const getStrength = (pw) => {
      let score = 0;
      if (pw.length >= 8) score++;
      if (pw.length >= 12) score++;
      if (/[A-Z]/.test(pw)) score++;
      if (/[0-9]/.test(pw)) score++;
      if (/[^A-Za-z0-9]/.test(pw)) score++;
      return score;
    };
   
    
    const strengthColors = ['#e24b4a', '#e24b4a', '#e55a00', '#f0ad00', '#0d6e28'];
      const strengthLabels = ['', 'Weak', 'Fair', 'Good', 'Strong'];
      const score = getStrength(values.password);
      const passwordsMatch =
        values.confirm_password.length > 0 &&
        values.password === values.confirm_password;
      const passwordsMismatch =
        values.confirm_password.length > 0 &&
        values.password !== values.confirm_password;

   
        const handlePasswordReset = async (e) => {
            e.preventDefault();
          
            if (values.password !== values.confirm_password) {
              toast.error("Passwords do not match");
              return;
            }
          
            setLoading(true);
          
            try {
              const res = await axios.post(
                `${API_URL}/forgot-password-updatepassword-api`,
                {
                  verify_code: verifyCode,
                  password: values.password,
                  confirm_password: values.confirm_password,
                }
              );
          
              if (res.data.Status === "Success") {
                toast.success("Password reset successful");
                localStorage.removeItem("verify_code");
                navigate(res.data.redirect);
              } else {
                toast.error(res.data.Message);
              }
            } catch (error) {
              toast.error("An error occurred. Please try again.");
            } finally {
              setLoading(false);
            }
          };
      
      

      
    return (
        <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center">
    <ToastContainer />
     
      <div style={{ width: '100%', maxWidth: '520px', margin: 'auto' }}>
               <div
                 style={{
                   background: '#ffffff',
                   borderRadius: '24px',
                   overflow: 'hidden',
                   boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                   animation: 'fadeInUp 0.5s ease-out',
                 }}
               >
                 {/* ── Header ── */}
                 <div
                   style={{
                     background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
                     padding: '1.5rem 1.5rem 1rem',
                     textAlign: 'center',
                   }}
                 >
                   <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.75rem' }}>
                     <div
                       style={{
                         width: '60px',
                         height: '60px',
                         background: 'rgba(255,255,255,0.15)',
                         borderRadius: '50%',
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                         animation: 'float 3s ease-in-out infinite',
                       }}
                     >
                       <i className="fas fa-lock-open" style={{ fontSize: '28px', color: 'white' }}></i>
                     </div>
                   </div>
                   <h3 style={{ color: 'white', margin: '0.5rem 0 0.25rem', fontSize: '1.3rem', fontWeight: '600' }}>
                     Reset Your Password
                   </h3>
                   <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.75rem', marginBottom: 0 }}>
                     Create a strong new password for your account
                   </p>
                 </div>
        
                 {/* ── Body ── */}
                 <div style={{ padding: '1.25rem' }}>
                   <form onSubmit={handlePasswordReset}>
        
                     {/* New Password */}
                     <div style={{ marginBottom: '1rem' }}>
                       <label
                         style={{
                           display: 'block',
                           fontSize: '0.75rem',
                           fontWeight: '600',
                           color: '#444',
                           marginBottom: '0.35rem',
                           textTransform: 'uppercase',
                           letterSpacing: '0.05em',
                         }}
                       >
                         New Password
                       </label>
                       <div
                         style={{
                           display: 'flex',
                           border: '1px solid #ced4da',
                           borderRadius: '40px',
                           overflow: 'hidden',
                           background: '#fff',
                           transition: 'box-shadow 0.2s, border-color 0.2s',
                         }}
                         onFocus={(e) => {
                           e.currentTarget.style.boxShadow = '0 0 0 3px rgba(13,110,40,0.15)';
                           e.currentTarget.style.borderColor = '#0d6e28';
                         }}
                         onBlur={(e) => {
                           e.currentTarget.style.boxShadow = '';
                           e.currentTarget.style.borderColor = '#ced4da';
                         }}
                       >
                         <input
                           type={showPassword ? 'text' : 'password'}
                           placeholder="Enter new password"
                           value={values.password}
                           onChange={(e) => setValues({ ...values, password: e.target.value })}
                           required
                           style={{
                             flex: 1,
                             border: 'none',
                             outline: 'none',
                             padding: '0.65rem 1rem',
                             fontSize: '0.85rem',
                             background: 'transparent',
                             color: '#333',
                           }}
                         />
                         <button
                           type="button"
                           onClick={() => setShowPassword(!showPassword)}
                           style={{
                             background: 'transparent',
                             border: 'none',
                             padding: '0 1rem',
                             cursor: 'pointer',
                             color: '#888',
                             display: 'flex',
                             alignItems: 'center',
                           }}
                         >
                           <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} style={{ fontSize: '16px' }}></i>
                         </button>
                       </div>
                     </div>
        
                     {/* Confirm Password */}
                     <div style={{ marginBottom: '1.25rem' }}>
                       <label
                         style={{
                           display: 'block',
                           fontSize: '0.75rem',
                           fontWeight: '600',
                           color: '#444',
                           marginBottom: '0.35rem',
                           textTransform: 'uppercase',
                           letterSpacing: '0.05em',
                         }}
                       >
                         Confirm New Password
                       </label>
                       <div
                         style={{
                           display: 'flex',
                           border: '1px solid #ced4da',
                           borderRadius: '40px',
                           overflow: 'hidden',
                           background: '#fff',
                           transition: 'box-shadow 0.2s, border-color 0.2s',
                         }}
                         onFocus={(e) => {
                           e.currentTarget.style.boxShadow = '0 0 0 3px rgba(13,110,40,0.15)';
                           e.currentTarget.style.borderColor = '#0d6e28';
                         }}
                         onBlur={(e) => {
                           e.currentTarget.style.boxShadow = '';
                           e.currentTarget.style.borderColor = '#ced4da';
                         }}
                       >
                         <input
                           type={showConfirmPassword ? 'text' : 'password'}
                           placeholder="Confirm new password"
                           value={values.confirm_password}
                           onChange={(e) => setValues({ ...values, confirm_password: e.target.value })}
                           required
                           style={{
                             flex: 1,
                             border: 'none',
                             outline: 'none',
                             padding: '0.65rem 1rem',
                             fontSize: '0.85rem',
                             background: 'transparent',
                             color: '#333',
                           }}
                         />
                         <button
                           type="button"
                           onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                           style={{
                             background: 'transparent',
                             border: 'none',
                             padding: '0 1rem',
                             cursor: 'pointer',
                             color: '#888',
                             display: 'flex',
                             alignItems: 'center',
                           }}
                         >
                           <i
                             className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                             style={{ fontSize: '16px' }}
                           ></i>
                         </button>
                       </div>
        
                       {/* Match feedback */}
                       {passwordsMatch && (
                         <p style={{ fontSize: '0.7rem', marginTop: '0.35rem', paddingLeft: '0.5rem', color: '#0d6e28', marginBottom: 0 }}>
                           ✓ Passwords match
                         </p>
                       )}
                       {passwordsMismatch && (
                         <p style={{ fontSize: '0.7rem', marginTop: '0.35rem', paddingLeft: '0.5rem', color: '#e24b4a', marginBottom: 0 }}>
                           ✗ Passwords do not match
                         </p>
                       )}
                     </div>
        
                     {/* Strength bar */}
                     {values.password.length > 0 && (
                       <div style={{ marginBottom: '1rem' }}>
                         <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.65rem', color: '#999', marginBottom: '4px' }}>
                           <span>Password strength</span>
                           <span style={{ color: strengthColors[Math.max(0, score - 1)] }}>
                             {strengthLabels[Math.min(score, 4)]}
                           </span>
                         </div>
                         <div style={{ height: '4px', background: '#e5ede8', borderRadius: '4px', overflow: 'hidden' }}>
                           <div
                             style={{
                               height: '100%',
                               width: `${score * 20}%`,
                               borderRadius: '4px',
                               transition: 'all 0.3s ease',
                               background: strengthColors[Math.max(0, score - 1)],
                             }}
                           />
                         </div>
                       </div>
                     )}
        
                     {/* Update Password Button */}
                     <button
                       type="submit"
                       disabled={loading}
                       style={{
                         width: '100%',
                         background: loading ? '#c0cfc5' : '#0d6e28',
                         border: 'none',
                         borderRadius: '40px',
                         padding: '0.7rem',
                         fontWeight: '600',
                         fontSize: '0.85rem',
                         cursor: loading ? 'not-allowed' : 'pointer',
                         color: '#ffffff',
                         marginBottom: '0.75rem',
                         transition: 'all 0.2s ease',
                       }}
                       onMouseEnter={(e) => { if (!loading) e.target.style.background = '#0a5520'; }}
                       onMouseLeave={(e) => { if (!loading) e.target.style.background = '#0d6e28'; }}
                     >
                       {loading ? (
                         <>
                           <span
                             className="spinner-border spinner-border-sm me-2"
                             role="status"
                             style={{ width: '0.8rem', height: '0.8rem' }}
                           ></span>
                           Updating...
                         </>
                       ) : (
                         <>
                           <i className="fas fa-save me-2"></i>
                           Update Password
                         </>
                       )}
                     </button>
        
                     {/* Back to Login */}
                     <button
                       type="button"
                       onClick={() => navigate('/')}
                       style={{
                         width: '100%',
                         padding: '0.7rem',
                         backgroundColor: 'transparent',
                         color: '#0d6e28',
                         border: '1.5px solid #0d6e28',
                         borderRadius: '40px',
                         fontSize: '0.85rem',
                         fontWeight: '600',
                         cursor: 'pointer',
                         marginBottom: '0.75rem',
                         transition: 'all 0.2s ease',
                       }}
                       onMouseEnter={(e) => {
                         e.target.style.backgroundColor = '#0d6e28';
                         e.target.style.color = 'white';
                       }}
                       onMouseLeave={(e) => {
                         e.target.style.backgroundColor = 'transparent';
                         e.target.style.color = '#0d6e28';
                       }}
                     >
                       <i className="fas fa-sign-in-alt me-2"></i>
                       Back to Login
                     </button>
        
                     {/* Already have account note */}
                     <div style={{ background: '#f8fcf9', borderRadius: '8px', padding: '0.5rem', textAlign: 'center' }}>
                       <p style={{ fontSize: '0.65rem', color: '#999', margin: 0 }}>
                         <i className="fas fa-shield-alt" style={{ marginRight: '5px' }}></i>
                         Already have an account?{' '}
                         <Link to="/" style={{ color: '#0d6e28', textDecoration: 'none', fontWeight: '600' }}>
                           Login here
                         </Link>
                       </p>
                     </div>
        
                   </form>
                 </div>
        
                 {/* ── Footer ── */}
                 <div
                   style={{
                     borderTop: '1px solid #e5ede8',
                     padding: '0.6rem',
                     background: '#fafdfb',
                     textAlign: 'center',
                   }}
                 >
                   <p style={{ fontSize: '0.6rem', color: '#8aa899', margin: 0 }}>
                     <i className="fas fa-headset me-1"></i>
                     Need help? Contact support@oret.africa
                   </p>
                 </div>
               </div>
             </div>
        
             {/* Animations */}
             <style>{`
               @keyframes fadeInUp {
                 from { opacity: 0; transform: translateY(20px); }
                 to   { opacity: 1; transform: translateY(0); }
               }
               @keyframes float {
                 0%, 100% { transform: translateY(0); }
                 50%       { transform: translateY(-5px); }
               }
             `}</style>
</div>

    );
}

export default ForgotPasswordReset;
